// Colors
export const COLOR_LIGHT_GREY = '#e0e0e0';
export const COLOR_PRIMARY_RED = '#f5333f';
export const COLOR_WHITE = '#ffffff';
export const COLOR_TEXT = '#313131';
export const COLOR_TEXT_ON_DARK = COLOR_WHITE;
export const COLOR_DARK_GREY = '#a5a5a5';
export const COLOR_BLACK = '#000000';
export const COLOR_LIGHT_RED = '#FDD6D9';

export const KEY_USER_STORAGE = 'user';

// Translation
export const KEY_LANGUAGE_STORAGE = 'lang';

// Date
export const DATE_FORMAT = 'MM/dd/yyyy hh:mm:ss';
